import { useEffect, useState } from 'react';
import DeleteButton from './Buttons/DeleteButton';

function BulkActionMenu({
  show,
  selectedElements,
  onDelete,
  onSelectAll,
  onClose,
  allElementsCount,
  children,
}) {
  const [allElementsSelected, setAllElementsSelected] = useState(false);

  useEffect(() => {
    if (selectedElements.length === allElementsCount) {
      setAllElementsSelected(true);
    } else {
      setAllElementsSelected(false);
    }
  }, [selectedElements, allElementsCount]);

  return (
    <div
      className={`position-fixed d-flex gap-3 justify-content-between border border-primary py-2 px-3 bg-white rounded mx-auto ${
        show ? 'd-flex' : 'd-none opacity-0'
      }`}
      style={{
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '95%',
      }}
    >
      <div
        className='bg-light rounded py-2 py-sm-1 px-2 px-xl-3 d-flex gap-1'
        style={{ fontSize: '14px' }}
      >
        <div className='d-flex justify-content-between justify-content-lg-start align-items-center gap-2'>
          <span
            role='button'
            className='material-symbols-outlined'
            style={{ fontSize: '18px' }}
            onClick={onClose}
          >
            close
          </span>
          <span className='text-secondary-black'>
            {selectedElements?.length} valda objekt
          </span>

          {selectedElements.length > 0 && !allElementsSelected && (
            <span
              role='button'
              className='text-blue d-none d-lg-block'
              onClick={() => onSelectAll()}
            >
              Välj alla {allElementsCount} objekt
            </span>
          )}
        </div>

        {selectedElements.length > 0 && !allElementsSelected && (
          <span
            role='button'
            className='text-blue d-block d-lg-none'
            onClick={() => onSelectAll()}
          >
            Välj alla {allElementsCount} objekt
          </span>
        )}
      </div>

      <div className='d-flex flex-row align-items-lg-center'>
        {children}
        {onDelete && (
          <DeleteButton
            onClick={() => {
              onDelete();
            }}
            disabled={selectedElements.length === 0}
          />
        )}
      </div>
    </div>
  );
}

export default BulkActionMenu;
